import { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { IconProps } from './icon.types';

export const DataRoomIcon: FC<IconProps> = ({ iconColor = '#475467', className, ...props }) => (
  <svg
    className={twMerge('shrink-0', className)}
    fill="none"
    height="20"
    viewBox="0 0 20 20"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.222 11.332C8.222 11.803 8.41 12.255 8.743 12.589C9.076 12.922 9.528 13.11 10 13.11C10.471 13.11 10.924 12.922 11.257 12.589C11.59 12.255 11.778 11.803 11.778 11.332C11.778 10.86 11.59 10.408 11.257 10.075C10.924 9.741 10.471 9.554 10 9.554C9.528 9.554 9.076 9.741 8.743 10.075C8.41 10.408 8.222 10.86 8.222 11.332Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M10 13.112V16.667"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
    <path
      d="M7.333 3.333H3.778C3.306 3.333 2.854 3.52 2.521 3.854C2.187 4.187 2 4.639 2 5.111V14.888C2 15.36 2.187 15.812 2.521 16.145C2.854 16.479 3.306 16.666 3.778 16.666H16.222C16.694 16.666 17.146 16.479 17.479 16.145C17.813 15.812 18 15.36 18 14.888V7.777C18 7.306 17.813 6.854 17.479 6.52C17.146 6.187 16.694 5.999 16.222 5.999H10L7.333 3.333Z"
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);
